import { Navigate } from 'react-router-dom';
import { useAuth } from '../../store/auth-context';
import { routes } from '../../lib/routes';

interface RequireOrgAdminProps {
  children: React.ReactNode;
}

/**
 * Gate for `/c/org/*` routes. Renders nothing while auth is loading (the
 * outer ProtectedRoute already shows a loading spinner) and redirects
 * non-admins to the console root.
 */
export default function RequireOrgAdmin({ children }: RequireOrgAdminProps) {
  const { user, isLoading } = useAuth();

  if (isLoading) return null;

  if (!user || user.role !== 'admin') {
    return <Navigate to={routes.console.root} replace />;
  }

  return <>{children}</>;
}
